import { AccountTypes } from "../enums/accountTypes.enum";

export const getAccountType = (accountTypeId: number): AccountTypes => {
    switch (accountTypeId) {
        case 0:
            return AccountTypes.ADMIN;
        case 1:
            return AccountTypes.CASE_MANAGER;
        case 2:
            return AccountTypes.EMPLOYER_OF_WORK_COMP_PATIENT;
        case 3:
            return AccountTypes.INSURANCE_ADJUSTER;
        case 4:
            return AccountTypes.REFERRAL_PARTNER;
        default:
            throw new Error('Unknown account type');
    }
};
